import { render, staticRenderFns } from "./editAppoint.vue?vue&type=template&id=48863959&scoped=true&"
import script from "./editAppoint.vue?vue&type=script&lang=js&"
export * from "./editAppoint.vue?vue&type=script&lang=js&"
import style0 from "./editAppoint.vue?vue&type=style&index=0&id=48863959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48863959",
  null
  
)

export default component.exports